const Types = {
    CLEAR: '@recepcao-contratos/CLEAR', 
    SEARCH_REQUEST: '@recepcao-contratos/SEARCH_REQUEST', 
    SEARCH_SUCCESS: '@recepcao-contratos/SEARCH_SUCCESS', 
    REQUEST_FAILURE: '@recepcao-contratos/REQUEST_FAILURE',
    RECEPCIONAR_REQUEST: '@recepcao-contratos/RECEPCIONAR_REQUEST', 
    RECEPCIONAR_SUCCESS: '@recepcao-contratos/RECEPCIONAR_SUCCESS',
    SEARCH_USUARIOS_REQUEST: '@recepcao-contrato/SEARCH_USUARIOS_REQUEST',
    SEARCH_USUARIOS_SUCCESS: '@recepcao-contrato/SEARCH_USUARIOS_SUCCESS'

};

export default Types;